export default __webpack_public_path__ + "static/media/plusIcon.fa26a718.svg";